module.exports = __webpack_public_path__ + "static/media/Pulse Module 1.1e0f1bb4.jpg";